import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormSpy } from 'react-final-form';

import api from '../api';
import { getIsConnectionFailedMessageVisible } from '../selectors/login';
import { closeSignUpModal, openLoginModal, openRequestSentModal } from '../actions/auth';
import { composeValidators, email, required } from '../helpers/formValidators';

import { FormLabel, FormInput, FormFeedback, BaseForm } from './form';
import { PrimaryButton } from './buttons';
import ErrorMessage from './ErrorMessage/ErrorMessage';
import './Login.css';

const SignUp = props => {
  const {
    openLoginModal,
    closeSignUpModal,
    connectionFailed,
    createRequest,
    openRequestSentModal,
  } = props;

  const handleSubmit = values => {
    const errors = {};
    return createRequest(
      {},
      {
        body: JSON.stringify({
          ...values
        })
      }
    ).then(data => {
      if (data.error) {
        errors.email = 'An account already exists for that email'
        return errors;
      }

      closeSignUpModal();
      openRequestSentModal();

    }).catch(error => {
      return <ErrorMessage />
    })
  }

  return (
    <div>
      <div className="page-header">
        <h3>Sign Up</h3>
      </div>
      <div className="login-container container">
        <BaseForm className="login-form"
          onSubmit={handleSubmit}
          buttons={'PrimaryButton'}
          noValidate
        >
          <p>Already have an account &nbsp;
            <a
              className="text-link"
              onClick={() => { closeSignUpModal(); openLoginModal(); }}
            >
              Log In
            </a>
          </p>
          <div className="input-container">
            <FormInput
              labelRenderer={() => <FormLabel>{'First Name'}</FormLabel>}
              id="signUp.firstName"
              name="firstName"
              type="text"
              validate={required}
            />

            <FormInput
              labelRenderer={() => <FormLabel>{'Last Name'}</FormLabel>}
              id="signUp.lastName"
              name="lastName"
              type="text"
              validate={required}
            />
          </div>

          <FormInput
            labelRenderer={() => <FormLabel>{'Email'}</FormLabel>}
            id="signUp.email"
            name="email"
            type="email"
            validate={composeValidators(required, email)}
          />


          {connectionFailed && (
            <FormFeedback positive={false}>No internet connection</FormFeedback>
          )}

          <FormInput
            labelRenderer={() => <FormLabel>{'Room Number'}</FormLabel>}
            name="room"
            type="text"
          />

          <div className="login-container__footer">
            <FormSpy subscription={{ invalid: true, submitting: true, submitErrors: true, modifiedSinceLastSubmit: true }}>
              {({ invalid, submitting, submitErrors, modifiedSinceLastSubmit }) => {
                if (submitErrors && modifiedSinceLastSubmit) {
                  submitErrors = {};
                  invalid = false;
                }

                return (
                  <PrimaryButton
                    type="submit"
                    label="Request Access"
                    disabled={invalid || submitting || connectionFailed}
                  />
                )
              }}
            </FormSpy>
          </div>
        </BaseForm>
      </div>
    </div>
  );
}

SignUp.propTypes = {
  handleSubmit: PropTypes.func,
  isConnectionFailedMessageVisible: PropTypes.bool.isRequired,
  closeSignUpModal: PropTypes.func.isRequired,
  handleOpenLoginModal: PropTypes.func.isRequired,
};


const mapStateToProps = state => (
  {
    connectionFailed: getIsConnectionFailedMessageVisible(state)
  }
)

const mapDispatchToProps = dispatch => (
  bindActionCreators(
    {
      closeSignUpModal,
      openLoginModal,
      openRequestSentModal,
      createRequest: api.actions.requestsCreate
    },
    dispatch
  )
)

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp.js